import { useState, useEffect } from "react";
import { Box, Card, Button, TextField, CardMedia } from "@mui/material";
import { UseMagLandings } from "./UseMagLandings";
import { useRecoilState } from "recoil";
import { rsProgress } from "../../RecoilStates";
import { FileUploader } from "react-drag-drop-files";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function MagLandingsFrame(props) {
  const fileTypes = [
    "JPG",
    "jpeg",
    "jfif",
    "pjpeg",
    "pjp",
    "PNG",
    "SVG",
    "webp",
    "GIF",
  ];
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { validate2, UpdateLandingInfo, AddLandingInfo } = UseMagLandings();
  const { isSmall } = useBreakpoints();
  const [state, setState] = useState({
    id: undefined,
    hid: props.hid ? props.hid : "",
    title: "",
    moreURL: undefined,
    moreTitle: undefined,
  });

  const [imgState, setImgState] = useState({
    file: undefined,
    url: "",
  });

  useEffect(() => {
    if (props.landingInfo) {
      setState({
        id: props.landingInfo.id,
        hid: props.hid,
        title: props.landingInfo.title ? props.landingInfo.title : "",
        moreURL: props.landingInfo.moreURL,
        moreTitle: props.landingInfo.moreTitle,
        description: props.landingInfo.description,
      });
      setImgState({
        file: undefined,
        url: props.landingInfo.icon ? props.landingInfo.icon : "",
      });
    }
  }, [props.landingInfo]);

  const [errorState, setErrorState] = useState({
    title: false,
    productCount: false,
  });

  const handleChangeImage = (file) => {
    setImgState({
      ...imgState,
      file: file[0],
      url: URL.createObjectURL(file[0]),
    });
  };

  const handleChangeImage2 = (file) => {
    setImgState({
      ...imgState,
      file2: file[0],
      url2: URL.createObjectURL(file[0]),
    });
  };

  return (
    <Box
      sx={{ border: "1px solid #E1E1E1", p: 2, borderRadius: 1 }}
      display="grid"
      gridTemplateColumns="repeat(12, 1fr)"
      gap={2}
    >
      <Box gridColumn={isSmall ? "span 12" : "span  4"}>
        <TextField
          fullWidth
          value={state.title ? state.title : ""}
          error={errorState.title}
          label="عنوان"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, title: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  4"}>
        <TextField
          fullWidth
          value={state.moreTitle ? state.moreTitle : ""}
          label="عنوان لینک"
          size="small"
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreTitle: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 8"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  6"}>
        <TextField
          fullWidth
          value={state.moreURL ? state.moreURL : ""}
          label="آدرس لینک"
          size="small"
          sx={{
            textarea: {
              direction: "rtl",
            },
          }}
          multiline
          rows={2}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, moreURL: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box gridColumn={isSmall ? "span 12" : "span  6"}>
        <TextField
          fullWidth
          value={state.description ? state.description : ""}
          label="توضیحات"
          size="small"
          multiline
          rows={3}
          variant="outlined"
          onChange={(evt) => {
            setState({ ...state, description: evt.target.value });
          }}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box
        gridColumn={isSmall ? "span 12" : "span  5"}
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          gap: 4,
        }}
      >
        <FileUploader
          multiple={true}
          handleChange={(evt) => handleChangeImage(evt)}
          name="file"
          types={fileTypes}
          children={
            <Box sx={{ width: "100px", height: "auto" }}>
              <Card
                sx={{
                  bgcolor: imgState.url && "#d7d7d7",
                  p: 1,
                  border: "1px",
                  borderStyle: "dashed",
                  borderColor: "secondary.main",
                  borderRadius: 4,
                  boxShadow: 0,
                  cursor: "pointer",
                }}
              >
                <CardMedia
                  component="img"
                  sx={{ width: "100%", height: "100%" }}
                  image={
                    imgState.url ? imgState.url : "/static/img/no-photos.png"
                  }
                />
              </Card>
            </Box>
          }
        />
      </Box>

      {!isSmall && <Box gridColumn="span 6"></Box>}
      <Box
        gridColumn="span 12"
        sx={{ mt: 2, display: "flex", justifyContent: "center" }}
      >
        <Button
          sx={{ mr: 2, width: "100px" }}
          variant="contained"
          onClick={() => {
            if (validate2(state, setErrorState) == 200) {
              setProgress(true);
              if (state.id == 0) {
                AddLandingInfo(state, imgState.file, (calback) => {
                  props.setLandingInfo(calback);
                });
                return;
              } else {
                UpdateLandingInfo(state, imgState.file, (calback) => {
                  props.setLandingInfo(calback);
                });
              }
            }
          }}
        >
          ثبت
        </Button>
      </Box>
    </Box>
  );
}
